import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FaCheck, FaLock, FaSignOutAlt } from 'react-icons/fa';

function NavbarSection({ isScrolled }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const userName = user?.username || user?.name || 'User';
  const userInitials = userName.charAt(0).toUpperCase();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const handleChangePassword = () => {
    navigate('/change-password');
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      isScrolled ? 'bg-slate-900/95 backdrop-blur-xl shadow-lg py-3' : 'bg-gradient-to-r from-slate-800 to-slate-700 py-4'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-wrap items-center justify-between gap-4">
        {/* Left Side */}
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center shadow-lg">
            <FaCheck className="w-6 h-6 text-white" />
          </div>
          <div className="hidden sm:block">
            <h1 className="text-white text-lg font-bold">Welcome to Advance Payment Recovery Course</h1>
            <p className="text-slate-400 text-sm">Master the art of payment recovery</p>
          </div>
        </div>

        {/* Right Side */}
        <div className="flex items-center gap-3">
          <div className="hidden md:flex items-center gap-3 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-xl border border-white/20">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center font-bold text-white">
              {userInitials}
            </div>
            <div>
              <p className="text-white font-semibold text-sm">{userName}</p>
              <p className="text-slate-400 text-xs">Student</p>
            </div>
          </div>
          <button 
            onClick={handleChangePassword}
            className="flex items-center gap-2 bg-gradient-to-r from-purple-500 to-purple-600 text-white px-4 py-2.5 rounded-xl font-semibold text-sm shadow-lg hover:-translate-y-0.5 transition-all"
          >
            <FaLock className="w-4 h-4" />
            <span className="hidden sm:inline">Change Password</span>
          </button>
          <button 
            onClick={handleLogout}
            className="flex items-center gap-2 bg-gradient-to-r from-red-500 to-red-600 text-white px-4 py-2.5 rounded-xl font-semibold text-sm shadow-lg hover:-translate-y-0.5 transition-all"
          >
            <FaSignOutAlt className="w-4 h-4" />
            <span className="hidden sm:inline">Logout</span>
          </button>
        </div>
      </div>
    </nav>
  );
}

export default NavbarSection;
